<template>
  <div class="drop"
    :class="getClasses"
    @dragover.prevent="dragOver"
    @dragleave.prevent="dragLeave"
    @drop.prevent="drop($event)">
        <div class="img" :class="key==0 ? 'first' : ''" v-for="(img,key) in imageSources" :key="key">
            <img :src="checkImage(img)" />
            <span @click="removeMe(key)" class="fas fa-times"></span>
        </div>

      <h1 class="text-center" v-if="imageSources.length == 0 && !isDragging">Drop some images</h1>

      <div class="manual">
        <label for="uploadmyfile">
          <p>or pick from device</p>
        </label>
        <input type="file" id="uploadmyfile" :accept="'image/*'" multiple @change="requestUploadFile">
      </div>

  </div>
</template>
<script>
import $ from 'jquery'

export default {
  name: 'DropImages',
  props:['location','folder','selected'],
  data(){
    return{
        isDragging:false,
        imageSources:[],
        name: [],
    }
  },
  mounted() {
    setTimeout(() => {
      if(this.selected){
        // var oldImages= JSON.parse(this.selected);
        // var self = this;
        // var imgColletion = [];
        // $.each(oldImages,function(key,val){
        //   imgColletion.push(self.URL_ROOT+"uploads/"+self.folder+"/"+val)
        // })
        // this.imageSources = imgColletion
         this.imageSources = JSON.parse(this.selected);
         this.name = JSON.parse(this.selected);
      }
    }, 1000);
  },
  computed:{
    getClasses(){
        return {isDragging: this.isDragging}
    }
  },
  methods:{
    removeMe(index){
        this.imageSources.splice(index,1)
        this.name.splice(index,1)
        this.$emit("input",this.name)
    },
    checkImage(img){
      if(img.indexOf('data:image/')==-1){
        return this.URL_ROOT+"uploads/"+this.folder+"/"+img
      }else{
        return img
      }
    },
    dragOver(){
        this.isDragging = true
    },
    dragLeave(){
        this.isDragging = false
    },
    async drop(e){
        var self = this;
        let files = [...e.dataTransfer.files]
        let images = files.filter(file => file.type.indexOf('image/') >= 0)
        let promises = []
        //let name = []
        images.forEach(file => {
            promises.push(this.getBase64(file))
            self.name.push(file.name);
        })
        let sources = await Promise.all(promises)
        console.log(sources);
        $.each(sources,function(key,val) {
            self.saveFile(val,self.name[key])
        })
        this.$emit("input",self.name)
        console.log("name",self.name);
        this.imageSources = this.imageSources.concat(sources)
        this.isDragging = false
    },
    requestUploadFile(){
        var src = this.$el.querySelector('#uploadmyfile')
        this.drop({dataTransfer:src})
    },
    saveFile(base64path,filename){
        $.ajax({
            "method": 'POST',
            "url": this.$root.URL_ROOT+'api.php',
            "data": {
                type:'multi_image',
                file:base64path,
                name: filename,
                folder: this.folder
            },
            "success": (response)=>{
                console.log(response);
            }
        })
    },
    getBase64(file) {
        const reader = new FileReader()
        return new Promise(resolve => {
            reader.onload = ev => {
                resolve(ev.target.result)
            }
            reader.readAsDataURL(file)
        })
    }
  }
}
</script>



<style scoped>
.drop{
  width: 100%;
  height: 100%;
  background-color: #eee;
  border:10px solid #eee;
  display: block;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  transition: background-color .2s ease-in-out;
  font-family: sans-serif;
  overflow: hidden;
  position: relative;
  min-height: 250px;
}
.drop::after, .drop::before {
    clear: both;
    display: table;
    content: '';
}
.isDragging{
  background-color: #999;
  border-color: #fff;
}
.img{
    padding: 1px;
    display: inline-block;
    align-items: center;
    justify-content: center;
    width: 150px;
    height: 150px;
    background-color: #000;
    margin: 2px;
    border-radius: 10px;
    vertical-align: top;
    float: left;
}
img{
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.img.first{
    width: 305px;
    height: 305px;
}
.img span {
    position: absolute;
    color: #fff;
    margin-left: -30px;
    margin-top: 1px;
    font-size: 35px;
    cursor: pointer;
}
.manual{
  position: absolute;
  bottom:0;
  width:100%;
  text-align:center;
  font-size:.8rem;
  text-decoration: underline;
}
#uploadmyfile{
  display: none;
}
</style>
